/*
  iwd-card-swatch: product card colour dots + photo loading.
  Markup comes from snippets/card-swatch.liquid (data-* on each dot), card-product-collection.liquid
  and card-product-category.liquid.
  - Tapping a dot switches the whole card to that colour without a page load: photos, both name links,
    price, stars, badges, quick add. Any part that is missing on a card is skipped.
  - Hover photos (img[data-rn-hover-src]) get their own files on mouse devices only, after load or on
    the first hover, so phones never download them. window.iwdPromoteHoverImages() re-runs this after
    infinite scroll adds cards (sections/main-collection-product-grid.liquid).
  - Deferred card photos (img[data-iwd-defer], homepage rails) load when the card nears the viewport.
  Rebuilt Oct 12 2026: the Oct 5 theme-editor save referenced this file but never uploaded it.
*/
(function () {
  if (window.__iwdCardSwatch) return;
  window.__iwdCardSwatch = 1;

  var MOUSE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- deferred photos (homepage rails) ---------- */
  function loadDeferred(img) {
    if (img.getAttribute('src')) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) img.setAttribute('srcset', ss);
    var s = img.getAttribute('data-src');
    if (s) img.setAttribute('src', s);
  }
  var deferIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      deferIO.unobserve(e.target);
      loadDeferred(e.target);
    });
  }, { rootMargin: '600px 0px' }) : null;
  function initDeferred(root) {
    (root || document).querySelectorAll('img[data-iwd-defer]:not([src])').forEach(function (img) {
      if (img.__iwdDefer) return;
      img.__iwdDefer = 1;
      if (deferIO) deferIO.observe(img); else loadDeferred(img);
    });
  }

  /* ---------- hover photos (mouse only) ---------- */
  function promote(img) {
    if (img.__iwdHover) return;
    img.__iwdHover = 1;
    var ss = img.getAttribute('data-rn-hover-srcset');
    var s = img.getAttribute('data-rn-hover-src');
    if (ss) img.setAttribute('srcset', ss);
    if (s) img.setAttribute('src', s);
  }
  function promoteCard(card) {
    card.querySelectorAll('img[data-rn-hover-src]').forEach(promote);
  }
  window.iwdPromoteHoverImages = function () {
    if (!MOUSE) return;
    document.querySelectorAll('img[data-rn-hover-src]').forEach(promote);
  };
  if (MOUSE) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('.card-wrapper');
      if (card) promoteCard(card);
    }, { passive: true });
  }

  /* ---------- colour switch ---------- */
  function attr(el, n) { return el.getAttribute(n) || ''; }

  function setImages(card, dot) {
    var front = attr(dot, 'data-image'), hover = attr(dot, 'data-image-hover'), alt = attr(dot, 'data-alt');
    var media = card.querySelector('.card__media .media');
    if (!media || !front) return;
    var imgs = media.querySelectorAll(':scope > img');
    if (!imgs.length) return;
    var first = imgs[0];
    first.removeAttribute('srcset');
    first.removeAttribute('data-srcset');
    first.setAttribute('src', front);
    if (alt) first.setAttribute('alt', alt);
    for (var i = 1; i < imgs.length; i++) {
      var im = imgs[i];
      im.removeAttribute('srcset');
      im.removeAttribute('data-srcset');
      im.removeAttribute('data-rn-hover-srcset');
      im.removeAttribute('data-rn-hover-src');
      im.__iwdHover = 1;
      // No second photo for this colour: show the front photo on hover too.
      im.setAttribute('src', i === 1 && hover ? hover : front);
    }
  }

  function setLinks(card, dot) {
    var url = attr(dot, 'data-hash');
    if (!url) return;
    card.querySelectorAll('a.card__media, .card__heading a.full-unstyled-link').forEach(function (a) {
      a.setAttribute('href', url);
    });
    var name = attr(dot, 'data-card-name');
    if (name) {
      card.querySelectorAll('.card__heading a.full-unstyled-link').forEach(function (a) {
        if (a.textContent.trim()) a.textContent = name;
      });
    }
  }

  function setPrice(card, dot) {
    var price = attr(dot, 'data-price'), compare = attr(dot, 'data-compare');
    var box = card.querySelector('.price:not(.card__badge)'); // the badge wrapper also carries .price
    if (!box || !price) return;
    box.classList.toggle('price--on-sale', !!compare);
    box.querySelectorAll('.price__regular .price-item--regular, .price-item--sale, .price__sale .price-item--last').forEach(function (el) {
      if (el.tagName !== 'S') el.innerHTML = price;
    });
    box.querySelectorAll('.price__sale s.price-item--regular').forEach(function (el) {
      el.innerHTML = compare;
    });
  }

  function setRating(card, dot) {
    var row = card.querySelector('.rn-card-rating');
    if (!row) return;
    var r = parseFloat(attr(dot, 'data-rating')) || 0, n = parseInt(attr(dot, 'data-rating-count'), 10) || 0;
    if (!n) { row.style.display = 'none'; return; }
    row.style.display = '';
    row.setAttribute('aria-label', r + ' out of 5 stars, ' + n + ' reviews');
    var stars = row.querySelector('.rn-card-rating__stars');
    if (stars) stars.style.setProperty('--rn-rating', Math.round(r / 5 * 100) + '%');
    var count = row.querySelector('.rn-card-rating__count');
    if (count) count.textContent = n + ' Reviews';
  }

  function setBadges(card, dot) {
    var holder = card.querySelector('.card__badge');
    if (!holder) return;
    var list = attr(dot, 'data-badges').split('|').filter(function (b) { return b.trim(); });
    holder.innerHTML = '';
    list.forEach(function (b) {
      var s = document.createElement('span');
      s.className = 'badge badge--bottom-left color-scheme-3';
      s.textContent = b.trim();
      holder.appendChild(s);
    });
  }

  function setQuickAdd(card, dot) {
    var handle = attr(dot, 'data-handle'), img = attr(dot, 'data-image');
    card.querySelectorAll('.quick-add-size-btn').forEach(function (btn) {
      if (handle) btn.setAttribute('data-product-handle', handle);
      if (img) btn.setAttribute('data-image', img);
    });
  }

  function setActive(dot) {
    var wrap = dot.closest('.swatch') || dot.parentNode.parentNode;
    wrap.querySelectorAll('a.grid-color').forEach(function (a) {
      var on = a === dot;
      a.classList.toggle('is-active', on);
      a.classList.toggle('active', on);
      a.classList.toggle('redirect', !on);
      a.setAttribute('aria-pressed', on ? 'true' : 'false');
      var el = a.closest('.swatch-element');
      if (el) el.classList.toggle('active-color', on);
    });
  }

  function switchCard(dot) {
    var card = dot.closest('.card-wrapper');
    if (!card) {
      var url = attr(dot, 'data-hash');
      if (url) window.location.href = url;
      return;
    }
    if (dot.classList.contains('is-active')) return;
    [setImages, setLinks, setPrice, setRating, setBadges, setQuickAdd].forEach(function (fn) {
      try { fn(card, dot); } catch (err) {}
    });
    setActive(dot);
  }

  function dotFrom(e) {
    var t = e.target;
    return t && t.closest ? t.closest('.swatch-element a.grid-color[data-hash]') : null;
  }
  document.addEventListener('click', function (e) {
    var dot = dotFrom(e);
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    switchCard(dot);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = dotFrom(e);
    if (!dot) return;
    e.preventDefault();
    switchCard(dot);
  });

  /* ---------- start ---------- */
  function start() {
    initDeferred();
    if (MOUSE) {
      if (document.readyState === 'complete') window.iwdPromoteHoverImages();
      else window.addEventListener('load', window.iwdPromoteHoverImages);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { initDeferred(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
